import { Pipe, PipeTransform } from '@angular/core'
import { Enums } from '@cyborg-monorepo/hunter/common'
import { BadgeVariant } from '@hyperkit'

@Pipe({
  name: 'priorityBadge',
  pure: true,
  standalone: false,
})
export class PriorityBadgePipe implements PipeTransform {
  transform(priority: Enums.PriorityEnum): BadgeVariant {
    switch (priority) {
      case Enums.PriorityEnum.LOW:
        return 'success'
      case Enums.PriorityEnum.MEDIUM:
        return 'warning'
      case Enums.PriorityEnum.HIGH:
        return 'error'
      default:
        return 'information'
    }
  }
}
